<div *ngIf="assignmentGroup" class="group-panel fxFlex mb-16">
  <mat-expansion-panel
    [expanded]="panelOpenState"
    (opened)="onStateChange(true)"
    (closed)="onStateChange(false)"
    hideToggle
  >
    <mat-expansion-panel-header
      [collapsedHeight]="'58px'"
      [expandedHeight]="'64px'"
      class="panel-header"
      [ngClass]="
        (assignmentGroup | groupAssigmentsCompletePipe)
          ? 'panel-header-complete'
          : ''
      "
    >
      <mat-panel-title
        class="title-content flex-row-start-center fxFlex-38p"
        style="height: 58px"
      >
        <div style="padding-top: 4px">{{ assignmentGroup.name }}</div>
      </mat-panel-title>
      <mat-panel-description
        class="flex-row-end-center"
        style="margin-right: 0 !important; padding-right: 0 !important"
      >
        <div class="flex-row-end-center" style="height: 100%">
          <ng-template #assignmentFullHint>
            <div>{{ "ASSIGNMENTS.ASSIGNMENTS_COMPLETE" | translate }}</div>
          </ng-template>

          <div class="title mr-8 flex-row-end-center" style="text-align: end">
            <div>{{ assignmentGroup.count_label }}</div>
            <mat-icon
              *ngIf="assignmentGroup | groupAssigmentsCompletePipe"
              class="s-32 ml-8"
              color="accent"
              matTooltip="{{ 'ASSIGNMENTS.ASSIGNMENTS_COMPLETE' | translate }}"
              content-type="template"
            >
              {{ getIcon("CIRCLE_CHECK") }}
            </mat-icon>
          </div>

          <div class="toggle-icons mr-16 flex-row-start-center">
            <mat-icon *ngIf="panelOpenState" class="s-28">{{
              iconService.getIcon("UP")
            }}</mat-icon>
            <mat-icon *ngIf="!panelOpenState" class="s-28">{{
              iconService.getIcon("DOWN")
            }}</mat-icon>
          </div>

          <ng-container *ngxPermissionsOnly="P.ASSIGNMENT_EDIT">
            <div
              class="add-btn gt2-light-green flex-row-center-center"
              matTooltip="{{ 'ASSIGNMENTS.ADD_ASSIGNEMENT_HINT' | translate }}"
              (click)="$event.stopPropagation(); onIncrementGroup()"
            >
              <mat-icon style="color: black">{{
                iconService.getIcon("ADD")
              }}</mat-icon>
            </div>
          </ng-container>
        </div>
      </mat-panel-description>
    </mat-expansion-panel-header>

    <div class="flex-column">
      <!-- DETAILS -->
      <mat-card class="mt-16 flex-column fxFlex">
        <div class="flex-row-end-start fxFlex">
          <div class="fxFlex">
            <div class="fxFlex-50p">
              <div class="job-title">
                {{ assignmentGroup.job_function.name }}
              </div>
              <div
                *ngIf="assignmentGroup.details.requested_all_day"
                class="mb-8 flex-row"
              >
                <div class="details-prefix">
                  {{ "ASSIGNMENTS.REQUESTED_ALL_DAY" | translate }}: &nbsp;
                </div>
                <div class="details-value">{{ "GENERIC.YES" | translate }}</div>
              </div>
              <div
                *ngIf="!assignmentGroup.details.requested_all_day"
                class="mb-8 flex-row"
              >
                <div class="details-prefix">
                  {{ "ASSIGNMENTS.REQUESTED_ALL_DAY" | translate }}: &nbsp;
                </div>
                <div class="details-value">{{ "GENERIC.NO" | translate }}</div>
              </div>
              <div class="mb-8 flex-row">
                <div class="details-prefix">
                  {{ "ASSIGNMENTS.PLANNED_START" | translate }}: &nbsp;
                </div>
                <div class="details-value flex-row">
                  {{ assignmentGroup.details.requested_date_from }}
                  <div *ngIf="!assignmentGroup.details.requested_all_day">
                    &nbsp;{{ assignmentGroup.details.requested_time_from }}
                  </div>
                </div>
              </div>
              <div class="mb-8 flex-row">
                <div class="details-prefix">
                  {{ "ASSIGNMENTS.PLANNED_END" | translate }}: &nbsp;
                </div>
                <div class="details-value flex-row">
                  {{ assignmentGroup.details.requested_date_to }}
                  <div *ngIf="!assignmentGroup.details.requested_all_day">
                    &nbsp;{{ assignmentGroup.details.requested_time_to }}
                  </div>
                </div>
              </div>
            </div>

            <div class="fxFlex-50p">
              <div class="details-prefix mb-4">
                {{ "GENERIC.NOTES" | translate }}
              </div>
              <div
                [ngClass]="
                  assignmentGroup.details.note &&
                  assignmentGroup.details.note.length > 0
                    ? 'note'
                    : ''
                "
                [innerHTML]="assignmentGroup.details.note"
              ></div>
            </div>
          </div>

          <ng-container *ngxPermissionsOnly="P.ASSIGNMENT_EDIT">
            <button mat-button mat-icon-button (click)="onEdit()">
              <mat-icon color="accent" class="s-28">
                {{ getIcon("EDIT") }}
              </mat-icon>
            </button>
          </ng-container>
        </div>
      </mat-card>

      <!-- propositions -->
      <div class="card-title mt-24">
        {{ "ASSIGNMENTS.PROPOSALS" | translate }}
      </div>
      <div class="list-header flex-row">
        <div class="fxFlex-50p">
          {{ "GENERIC.NAME" | translate }}
        </div>
        <div class="fxFlex-50p">
          {{ "GENERIC.STATUS" | translate }}
        </div>
      </div>
      <div class="propositions-list" fusePerfectScrollbar>
        <!-- TRACKBY: trackBy -->
        <div
          *ngFor="let prop of assignmentGroup.proposals; trackBy: trackByUUID"
          class="propositions-item flex-row"
        >
          <div
            *ngIf="prop.employee"
            class="item-cell flex-row-start-center fxFlex-50p"
          >
            <div style="margin-right: 8px">
              {{ prop.employee.first_name }} {{ prop.employee.last_name }}
            </div>
            <mat-icon
              class="secondary-text icon-btn-prop"
              matTooltip="{{ 'ASSIGNMENTS.OPEN_EMPLOYEE' | translate }}"
              (click)="onViewEmployee(prop)"
              >{{ getIcon("EMPLOYEES") }}</mat-icon
            >
          </div>
          <div
            *ngIf="!prop.employee"
            class="item-cell flex-row-start-center fxFlex-50p"
          >
            &nbsp;
          </div>
          <div class="item-cell flex-row-start-center fxFlex-50p">
            <!-- <mat-label>{{ "ASSIGNMENTS.SELECT_STATUS" | translate }}</mat-label> -->
            <span *ngxPermissionsExcept="P.ASSIGNMENT_PUBLISH" class="iso">{{
              proposalStatusLabel(prop.status)
            }}</span>
            <mat-select
              *ngxPermissionsOnly="P.ASSIGNMENT_PUBLISH"
              [(ngModel)]="prop.status"
              (selectionChange)="onProposalStatusChange($event, prop)"
            >
              <mat-option
                *ngFor="let status of proposalsEnums"
                [value]="status.enum"
              >
                <span class="iso">{{ status.label }}</span>
              </mat-option>
            </mat-select>
          </div>
        </div>

        <div
          *ngIf="assignmentGroup.proposals.length === 0"
          style="padding: 16px"
          class="mat-h3 flex-row-center-center fxFlex"
        >
          {{ "ASSIGNMENTS.NO_PROPOSALS" | translate }}
        </div>
      </div>

      <!-- Assignements -->
      <div class="card-title mt-24">
        {{ "ASSIGNMENTS.ASSIGNMENTS" | translate }}
      </div>
      <div class="list-header scroll-space flex-row-start-center">
        <div class="fxFlex-28p">
          {{ "GENERIC.NAME" | translate }}
        </div>
        <div class="item-cell-bl fxFlex-28p">
          {{ "ASSIGNMENTS.SOURCE" | translate }}
        </div>
        <!-- DO NOT DELETE, TEMPORARY REMOVED -->
        <!-- <div class="item-cell-bl">{{ 'GENERIC.STATUS' | translate }}</div> -->
        <div class="item-cell-bl fxFlex-12p">
          {{ "ASSIGNMENTS.EXPENSES" | translate }}
        </div>
        <div class="item-cell-bl fxFlex-12p">
          {{ "ASSIGNMENTS.RATE" | translate }}
        </div>
        <div class="item-cell-bl fxFlex-88">
          {{ "ASSIGNMENTS.TIPS" | translate }}
        </div>
        <div class="item-cell-bl fxFlex-60">
          {{ "ASSIGNMENTS.MEAL" | translate }}
        </div>
        <div class="item-cell-bl fxFlex-95">
          {{ "ASSIGNMENTS.ACTIONS" | translate }}
        </div>
        <div class="item-cell-bl fxFlex-40">
          {{ "GENERIC.NOTES" | translate }}
        </div>
      </div>

      <div class="assignments-list">
        <cdk-virtual-scroll-viewport
          [itemSize]="10"
          class="list-vscroll"
          [ngClass]="
            assignmentGroup.jobs && assignmentGroup.jobs.length === 0
              ? 'list-vscroll-empty'
              : ''
          "
        >
          <div
            *cdkVirtualFor="
              let assignment of assignmentGroup.jobs;
              trackBy: trackByUUID
            "
            class="assignment-item flex-row"
          >
            <div class="item-cell flex-row-start-center fxFlex-28p">
              <div *ngIf="assignment.employee">
                {{ assignment.employee.name }}
              </div>
              <div *ngIf="assignment.staff_provider">
                {{ assignment.staff_provider.name }}
              </div>
            </div>

            <div
              *ngIf="!assignment.employee"
              class="item-cell item-cell-bl flex-row-start-center fxFlex-28p"
            >
              <app-gt2-select
                style="width: 100%"
                [useFloatValue]="'auto'"
                [service]="staffProvider"
                [nullableUseNone]="false"
                [placeHolder]="'ASSIGNMENTS.SELECT_STAFF_PROVIDER' | translate"
                [label]="''"
                [selectedModel]="assignment.staff_provider"
                (changeEvent)="onJobStaffProviderChange($event, assignment)"
                [noResultsLabel]="translate.instant('GENERIC.NO_RESULTS')"
                class="fxFlex-100p"
              >
              </app-gt2-select>

              <ng-container *ngxPermissionsOnly="P.ASSIGNMENT_EDIT">
                <mat-icon
                  class="secondary-text icon-btn"
                  matTooltip="{{ 'ASSIGNMENTS.DETACH_EXTRERNAL' | translate }}"
                  [ngClass]="
                    assignment.staff_provider !== null
                      ? ''
                      : 'icon-btn-disabled'
                  "
                  (click)="onUnlink(assignment)"
                  >{{ getIcon("LINK_OFF") }}</mat-icon
                >
              </ng-container>
            </div>

            <div
              *ngIf="assignment.employee"
              class="item-cell item-cell-bl flex-row-start-center fxFlex-28p"
            >
              {{ "ASSIGNMENTS.INTERNAL" | translate }}
            </div>

            <!-- DO NOT DELETE, TEMPORARY REMOVED -->
            <!-- <div class="item-cell item-cell-bl">
                        {{ assignment.status_label }}
                    </div> -->

            <ng-template #jobExpensesHint>
              <ul style="margin-right: 24px; text-align: start">
                <li *ngFor="let expense of assignment.job_expenses">
                  {{ expense.name }}: {{ expense.amount_label }}
                </li>
                <li
                  *ngIf="
                    !assignment.job_expenses ||
                    assignment.job_expenses.length === 0
                  "
                >
                  {{ "ASSIGNMENTS.NO_JOB_EXPENSES" | translate }}
                </li>
              </ul>
            </ng-template>

            <div
              class="item-cell item-cell-bl flex-row-start-center fxFlex-12p"
            >
              <ng-container *ngxPermissionsOnly="P.ASSIGNMENT_EXPENSES_EDIT">
                <div
                  class="flex-row-start-center"
                  (click)="onJobExpenses(assignment)"
                  matTooltip="{{ 'GENERIC.EDIT' | translate }} {{
                    'ASSIGNMENTS.JOB_EXPENSES' | translate | lowercase
                  }}"
                  style="cursor: pointer"
                >
                  {{ assignment.job_expenses_total_label }}
                  <mat-icon class="secondary-text icon-btn s-16 ml-8">{{
                    getIcon("EDIT")
                  }}</mat-icon>
                </div>
              </ng-container>
              <mat-icon
                class="s-20 ml-4 hint-tooltip"
                [matTooltip]="getExpensesTooltip(assignment)"
                content-type="template"
              >
                {{ getIcon("INFO") }}
              </mat-icon>
            </div>

            <ng-template #rateHint>
              <ul style="margin-right: 24px; text-align: start">
                <li>
                  {{ "ASSIGNMENTS.RATE" | translate }}:
                  {{ assignment.hourly_wage_label }}
                </li>
                <li>
                  {{ "GENERIC.DURATION" | translate }}:
                  {{ assignment.real_duration_label_hour }}
                </li>
                <li>
                  {{ "ASSIGNMENTS.TOTAL_COST" | translate }}:
                  {{ assignment.full_duration_cost_label }}
                </li>
              </ul>
            </ng-template>

            <div
              class="item-cell item-cell-bl flex-row-start-center fxFlex-12p"
            >
              <div
                *ngxPermissionsOnly="P.ASSIGNMENT_WAGE_VIEW"
                class="flex-row-start-center"
              >
                {{ assignment.hourly_wage_label }}
                <ng-container *ngxPermissionsOnly="P.ASSIGNMENT_EDIT">
                  <mat-icon
                    matTooltip="{{ 'GENERIC.EDIT' | translate }}"
                    (click)="onEditAssignment(assignment)"
                    class="secondary-text icon-btn s-20 ml-8"
                    >{{ getIcon("EDIT") }}</mat-icon
                  >
                </ng-container>
                <mat-icon
                  class="s-20 ml-4 hint-tooltip"
                  matTooltip="{{ 'ASSIGNMENTS.RATE' | translate }}:
                  {{ assignment.hourly_wage_label }} || 
                  {{ 'GENERIC.DURATION' | translate }}:
                  {{ assignment.real_duration_label_hour }} || 
                  {{ 'ASSIGNMENTS.TOTAL_COST' | translate }}:
                  {{ assignment.full_duration_cost_label }}"
                  content-type="template"
                >
                  {{ getIcon("INFO") }}
                </mat-icon>
              </div>
              <div
                *ngxPermissionsExcept="P.ASSIGNMENT_WAGE_VIEW"
                class="flex-row-center-center"
                style="width: 100%"
              >
                <button
                  class=""
                  mat-icon-button
                  matTooltip="{{ 'GENERIC.NO_PERMISSIONS' | translate }}"
                  content-type="template"
                  type="button"
                >
                  <mat-icon class="icon-btn s-20">help</mat-icon>
                </button>
              </div>
            </div>

            <div
              class="item-cell item-cell-bl flex-row-center-center fxFlex-88"
            >
              <div
                *ngIf="assignment.tips_enabled"
                class="flex-row-start-center"
              >
                <mat-icon color="accent" class="s-20 pr-8">
                  {{ getIcon("CHECK") }}
                </mat-icon>
                <div class="ml-4">{{ assignment.tips_amount_label }}</div>
              </div>
            </div>

            <div
              class="item-cell item-cell-bl flex-row-center-center fxFlex-60"
            >
              @if (assignment.meal_included === true) {
                <div class="pr-8">{{ "ASSIGNMENTS.YES" | translate }}</div>
              } @else {
                <div class="pr-8">{{ "ASSIGNMENTS.NO" | translate }}</div>
              }
            </div>

            <div class="item-cell item-cell-bl flex-row-start-center fxFlex-95">
              <mat-icon
                class="secondary-text icon-btn icon-action"
                matTooltip="{{ 'ASSIGNMENTS.OPEN_EMPLOYEE' | translate }}"
                [ngClass]="
                  assignment.employee !== null ? '' : 'icon-btn-disabled'
                "
                (click)="onViewEmployee(assignment)"
                >{{ getIcon("EMPLOYEES") }}</mat-icon
              >

              <ng-container *ngxPermissionsOnly="P.ASSIGNMENT_EDIT">
                <mat-icon
                  class="secondary-text icon-btn icon-action"
                  matTooltip="{{ 'GENERIC.EDIT' | translate }}"
                  (click)="onEditAssignment(assignment)"
                  >{{ getIcon("EDIT") }}</mat-icon
                >
              </ng-container>

              <ng-container *ngxPermissionsOnly="P.ASSIGNMENT_DELETE">
                <mat-icon
                  *ngIf="!assignment.employee && !assignment.staff_provider"
                  class="secondary-text icon-btn icon-action"
                  matTooltip="{{ 'GENERIC.DELETE' | translate }}"
                  (click)="onDeleteAssignment(assignment)"
                  >{{ getIcon("DELETE") }}</mat-icon
                >
              </ng-container>

              <mat-icon
                *ngIf="assignment.employee"
                class="secondary-text icon-btn icon-action icon-btn-disabled"
                matTooltip="{{
                  'ASSIGNMENTS.ASSIGNMENT_DELETE_EMLPOYEE_HINT' | translate
                }} {{ assignment.employee.name }}"
              >
                {{ getIcon("DELETE") }}
              </mat-icon>

              <mat-icon
                *ngIf="assignment.staff_provider"
                class="secondary-text icon-btn icon-action icon-btn-disabled"
                matTooltip="{{
                  'ASSIGNMENTS.ASSIGNMENT_DELETE_STAFF_PROVIDER_HINT'
                    | translate
                }} {{ assignment.staff_provider.name }}"
              >
                {{ getIcon("DELETE") }}
              </mat-icon>
            </div>
            <div
              class="item-cell item-cell-bl flex-row-center-center fxFlex-40"
            >
              <mat-icon
                *ngIf="assignment.note_instruction"
                matTooltip="{{
                  assignment.note_instruction.substring(0, noteHintMaxChar)
                }} {{
                  assignment.note_instruction.length > noteHintMaxChar
                    ? '...'
                    : ''
                }}"
                position="top"
                showDelay="200"
                hideDelay="200"
                class="s-20 icon-cursor"
              >
                {{ getIcon("INFO") }}
              </mat-icon>

              <mat-icon
                *ngIf="!assignment.note_instruction"
                class="s-20 note-icon-btn-disabled"
              >
                {{ getIcon("INFO") }}
              </mat-icon>
            </div>
          </div>
        </cdk-virtual-scroll-viewport>

        <div
          *ngIf="assignmentGroup.jobs.length === 0"
          style="padding: 16px"
          class="mat-h3 no-assignments flex-row-center-center fxFlex"
        >
          {{ "ASSIGNMENTS.NO_ASSIGNMENTS" | translate }}
        </div>
      </div>

      <div class="flex-row-center-start fxFlex">
        <ng-container *ngxPermissionsOnly="P.ASSIGNMENT_DELETE">
          <button
            mat-raised-button
            color="warn"
            class="mt-16"
            (click)="onDelete()"
          >
            {{ "GENERIC.DELETE" | translate }}
          </button>
        </ng-container>
      </div>
    </div>
  </mat-expansion-panel>
</div>
